module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB0SURBVChTlctBDYAwEATA48UXA0hABDLQgQ10VAYikIABvryAXXKXlHIpdJNJmuuuZDKoorSwKb5/pYIZTsU3b58ZwUaGt2w62CEd8sY/NzUskI4M/9h5ZQJvEGPnkR4O8Moxdti908AKXtHDLjcS9FBAwgWeW0W7hrSBcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./public/images/arrow_up.png
// module id = 1549
// module chunks = 1